import React, { useContext, useState, useEffect } from 'react';

import EditableName from './field_inputs/EditableName';
import EditableOwner from './field_inputs/EditableOwner';
import AddDeal from '../AddDeal';
import DetailsDropdown from './DetailDropdown';
import { DataContext as MainDataContext } from '../../../store';
import { DataContext } from '../../../stores/crm-organization-store';
import { DataContext as PersonDataContext } from '../../../stores/crm-person-store';
import { DataContext as DealDataContext } from '../../../stores/crm-deal-store';

const DetailHeader = ({ item, updateItemProps, itemType }) => {
    const {
        store: { user },
    } = useContext(MainDataContext);

    const {
        store: { rows },
        dispatch,
    } = useContext(DataContext);

    const {
        store: { rows: persRows },
        dispatch: persDispatch,
    } = useContext(PersonDataContext);
    const {
        store: { pipelines, currentPipelineId },
        dispatch: dealDispatch,
    } = useContext(DealDataContext);

    /**
     * @param {string} [itemType] "organization", "person"
     */

    let AddDealButton;
    let itemTypeName;
    //const isAdmin = user.isAdmin;
    //const isAdmin = item.OwnerId == user.crmUserId;

    const [isOwner, setIsOwner] = useState(item.owner.id === user.crmUserId);

    useEffect(() => {
        setIsOwner(item.owner.id === user.crmUserId);
    }, [item]);


    switch (itemType) {
        case 'organization':
            AddDealButton = <AddDeal initialValues={{ customer: item, name: `${item.name} deal` }} />;
            itemTypeName = 'organisation';
            break;
        case 'person':
            AddDealButton = (
                <AddDeal initialValues={{ contact: item, customer: item.organization, name: `${(item.organization || {}).name} deal` }} />
            );
            itemTypeName = 'person';
            break;
        default:
            AddDealButton = <AddDeal />;
            itemTypeName = 'objekt';
            break;
    }

    const updateStore = (newOrganizationOrPerson) => {
        const indexToUpdate = rows.findIndex((p) => p.id === newOrganizationOrPerson.id);
        rows[indexToUpdate] = newOrganizationOrPerson;

        if (indexToUpdate >= 0) {
            dispatch({ type: 'UPDATE_DATA', payload: rows });
        }
    };

    const updateOrganizationsInStore = (newOrganizationOrPerson) => {
        if (typeof pipelines[currentPipelineId] !== undefined && pipelines[currentPipelineId]?.pipelineStages !== undefined) {
            const indexToUpdate = rows.findIndex((p) => p.id === newOrganizationOrPerson.id);
            rows[indexToUpdate] = newOrganizationOrPerson;

            if (indexToUpdate >= 0) {
                for (var i = 0; i < rows.length; i++) {
                    if (rows[i].id == newOrganizationOrPerson.id) {
                        rows[i] = newOrganizationOrPerson;
                    }
                }

                for (var j = 0; j < persRows.length; j++) {
                    if (persRows[j].organization.id == newOrganizationOrPerson.id) {
                        persRows[j].organization = newOrganizationOrPerson;
                    }
                }

                for (var d = 0; d < pipelines[currentPipelineId].pipelineStages.length; d++) {
                    const deal = pipelines[currentPipelineId].pipelineStages[d].deals;
                    for (var x = 0; x < deal.length; x++) {
                        if (deal[x].customer.id == newOrganizationOrPerson.id) {
                            deal[x].customer = newOrganizationOrPerson;
                        }
                    }
                }

                dispatch({ type: 'UPDATE_DATA', payload: rows });
                persDispatch({ type: 'UPDATE_DATA', payload: persRows });
                dealDispatch({
                    type: 'UPDATE_FETCH_PIPES',
                    pipelines: pipelines,
                });
            }
        }
    };

    return (
        <div className='d-flex flex-column card detail-card-header w-100'>
            <div className='d-flex flex-row align-items-center'>
                <EditableName
                    description={`Döp om ${itemTypeName}:`}
                    customDisplayWrapper={(v) => <h1 className='crm-header'>{v}</h1>}
                    initialValue={item.name}
                    handleSave={(v) => updateItemProps({ name: v })}
                    updateStore={updateStore}
                    updateOrganizationsInStore={updateOrganizationsInStore}
                />
                <div className='d-flex ml-auto flex-row justify-content-center align-items-center'>
                    <EditableOwner initialValue={item.owner} handleSave={(v) => updateItemProps({ owner: v })} updateStore={updateStore} />
                    {AddDealButton}
                    {isOwner ? <DetailsDropdown itemType={itemType} /> : null}
                </div>
            </div>
        </div>
    );
};

export default DetailHeader;
